// extracted by mini-css-extract-plugin
module.exports = {"search_result_login_barrier":"LoginNotice_search_result_login_barrier__LZ3cQ"};